// ----------------------------------------------------------------------
// <copyright file="Izenda.DataModel.jsx" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

!(function () {
  "use strict";

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var SourceTree = require('../../SourceTree/Izenda.SourceTree');
  var observer = require('mobx-react').observer;

  var DataModel = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      workspaceDetail: React.PropTypes.object.isRequired
    },

    render: function () {
      var props = this.props;
      var store = props.store;
      var workspaceDetail = props.workspaceDetail;
      var localization = props.localization;

      return (
        workspaceDetail.copyDataModel &&
        <div className='u_tableCell u_paddingRight'>
          {localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_PLEASE_SELECT_DATASOURCE')}
          <SourceTree
            store={store}
            isDataModel={true}
            tree={workspaceDetail.querySourceTree}
            workspaceDetail={workspaceDetail}
            title={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SOURCE')}
            showCheckbox />
        </div>
      );
    }
  });

  module.exports = observer(connect()(DataModel));
} ());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/DataModel/Izenda.DataModel.jsx